 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		9: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"ea88be26","3":"e1e64ab71ecb1f98791f4433621b8fdb4f1e79c2","4":"0c030cf414428023b618336eb5981e010bfb0999","5":"c421250ae82186fd4368fab419f6f5e0731c3e32","6":"8bd402f095efac0f1b0ab6e907c3232b5d346031","7":"component---src-templates-podcasts-page-index-js","11":"component---src-pages-404-old-js","12":"component---src-templates-archive-index-js","13":"component---src-templates-archive-single-index-js","14":"component---src-templates-careers-index-js","15":"component---src-templates-careers-position-index-js","16":"component---src-templates-case-study-single-index-js","17":"component---src-templates-community-index-js","18":"component---src-templates-conversation-index-js","19":"component---src-templates-data-index-js","20":"component---src-templates-feed-index-js","21":"component---src-templates-legal-privacy-child-index-js","22":"component---src-templates-legal-privacy-index-js","23":"component---src-templates-media-coverage-index-js","24":"component---src-templates-newsroom-index-js","25":"component---src-templates-page-index-js","26":"component---src-templates-podcast-single-index-js","27":"component---src-templates-powered-by-template-index-js","28":"component---src-templates-preview-index-js","29":"component---src-templates-quality-moderation-and-safety-index-js","30":"component---src-templates-resources-index-js","31":"component---src-templates-single-index-js","32":"component---src-templates-spot-im-jobs-index-js","33":"component---src-templates-state-of-online-conversations-index-js","34":"component---src-templates-technology-index-js","35":"component---src-templates-tei-calculator-index-js","36":"component---src-templates-tei-result-index-js","37":"component---src-templates-webinar-single-index-js"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"0c53be408c90aa5319c2","2":"9a31bed18927b9d03eca","3":"db4a8ff40d00641f900a","4":"f46f5f4ccd87e1892045","5":"973cfb566617b11de7ef","6":"1814da67d7a185a2b7d1","7":"820fc8118c963567df57","11":"7ac0473780ec7fdd8cff","12":"83b336bb23dc6d7bde3b","13":"6aace478a53a2436d9d9","14":"ea56edd4e57107ba0c29","15":"dfcef144106257959044","16":"9459be40aa846666d757","17":"3a928da0c7514baa4339","18":"f54290a569b3507c07b2","19":"69eb94480dcf3df5b126","20":"02173947a03ed7e8e890","21":"71856ba89ebf4c77adc6","22":"da2c86048b1073f9952b","23":"73f1f4aae08dc42a9082","24":"08d1a54d983c80599c4d","25":"919184afcd71f180a493","26":"9d0149a9c841826da6bc","27":"729f0c02e18d23d8f42b","28":"c46b5599ac732fea011c","29":"05517587522f3e2bdab5","30":"92c82bad90bee6b20bfb","31":"939981892b7c5f6cea81","32":"c9c78bbd9e49e3c9ccb8","33":"2c536effac1fc9aed794","34":"d923bf5a2c687706de11","35":"41a22da4dfde76e839fa","36":"7ddc4480cce3323765f4","37":"676b639ef4c2f23eb7c2","40":"74bbaf113da32ecda75a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"ea88be26","3":"e1e64ab71ecb1f98791f4433621b8fdb4f1e79c2","4":"0c030cf414428023b618336eb5981e010bfb0999","5":"c421250ae82186fd4368fab419f6f5e0731c3e32","6":"8bd402f095efac0f1b0ab6e907c3232b5d346031","7":"component---src-templates-podcasts-page-index-js","11":"component---src-pages-404-old-js","12":"component---src-templates-archive-index-js","13":"component---src-templates-archive-single-index-js","14":"component---src-templates-careers-index-js","15":"component---src-templates-careers-position-index-js","16":"component---src-templates-case-study-single-index-js","17":"component---src-templates-community-index-js","18":"component---src-templates-conversation-index-js","19":"component---src-templates-data-index-js","20":"component---src-templates-feed-index-js","21":"component---src-templates-legal-privacy-child-index-js","22":"component---src-templates-legal-privacy-index-js","23":"component---src-templates-media-coverage-index-js","24":"component---src-templates-newsroom-index-js","25":"component---src-templates-page-index-js","26":"component---src-templates-podcast-single-index-js","27":"component---src-templates-powered-by-template-index-js","28":"component---src-templates-preview-index-js","29":"component---src-templates-quality-moderation-and-safety-index-js","30":"component---src-templates-resources-index-js","31":"component---src-templates-single-index-js","32":"component---src-templates-spot-im-jobs-index-js","33":"component---src-templates-state-of-online-conversations-index-js","34":"component---src-templates-technology-index-js","35":"component---src-templates-tei-calculator-index-js","36":"component---src-templates-tei-result-index-js","37":"component---src-templates-webinar-single-index-js"}[chunkId]||chunkId) + "." + {"0":"589bc069159ba7b84db0","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
